"use client";

import React from "react";
import { Anchor } from "./Anchor";
import { Text } from "./Text";
import { ChevronRight } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadCrumbsProps {
  className?: string;
  items: BreadcrumbItem[];
}

export function BreadCrumbs({ items, className }: BreadCrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={className ? className : ""}>
      <ol className="flex">
        {items.map(({ label, href }, i) => {
          if (!label) return null;
          if (href && i < items.length - 1) {
            return (
              <li key={i} className="flex items-end">
                <Anchor href={href}>{label}</Anchor>
                <ChevronRight size={16} className="mx-1 mb-1 text-secondary" />
              </li>
            );
          }
          return (
            <li key={i}>
              <Text>{label}</Text>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
